/* Pure Lust — Gevoel arc reveal animation
 * Adds `is-visible` to each .pl-arc__phase when it enters the viewport.
 * Pure progressive enhancement — no JS = phases all visible (see CSS .no-js fallback).
 */
(function () {
  if (!('IntersectionObserver' in window)) {
    document.querySelectorAll('.pl-arc__phase').forEach(function (el) {
      el.classList.add('is-visible');
    });
    return;
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.18, rootMargin: '0px 0px -8% 0px' });

  function init() {
    var section = document.querySelector('.pl-arc');
    if (section) section.classList.add('pl-arc--js');
    // SAFETY: mark every phase visible immediately. The observer-based fade-in
    // turned out to leave phases invisible when the page is opened mid-scroll
    // (or rendered via full-page screenshot). Beautiful matters more than a
    // first-paint reveal animation.
    document.querySelectorAll('.pl-arc__phase').forEach(function (el) {
      el.classList.add('is-visible');
    });

    initBundleAdd();
    initAlts();
  }

  /* ── Inline alternatieven-carousel per fase-showcase ───────────────────── */
  function initAlts() {
    var groups = document.querySelectorAll('[data-pl-arc-alts]');
    groups.forEach(function (group) {
      var showcase = group.closest('[data-pl-arc-showcase]');
      if (!showcase) return;
      var track = group.querySelector('[data-pl-arc-track]');
      var alts = Array.prototype.slice.call(group.querySelectorAll('[data-pl-arc-alt]'));
      if (!alts.length) return;

      var mediaImg = showcase.querySelector('[data-pl-arc-media]');
      var titleEl = showcase.querySelector('[data-pl-arc-title]');
      var priceEl = showcase.querySelector('[data-pl-arc-price]');
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function select(alt) {
        alts.forEach(function (a) { a.classList.remove('is-selected', 'is-pinned'); });
        alt.classList.add('is-selected', 'is-pinned');

        showcase.setAttribute('data-selected-variant', alt.getAttribute('data-variant-id') || '');
        showcase.setAttribute('data-selected-price', alt.getAttribute('data-price') || '0');
        showcase.setAttribute('data-selected-title', alt.getAttribute('data-title') || '');
        showcase.setAttribute('data-selected-thumb', alt.getAttribute('data-thumb') || '');

        var lg = alt.getAttribute('data-img-large');
        if (mediaImg && lg) mediaImg.src = lg;
        if (titleEl) titleEl.textContent = alt.getAttribute('data-title') || titleEl.textContent;
        if (priceEl) priceEl.textContent = alt.getAttribute('data-price-formatted') || priceEl.textContent;

        recomputeBundle();
      }

      alts.forEach(function (alt) {
        alt.addEventListener('click', function () {
          alt.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', inline: 'center', block: 'nearest' });
          select(alt);
        });
      });

      // Pin = gecentreerde kaart; bij scroll-stop wordt die de keuze.
      if (track) {
        var t = null;
        track.addEventListener('scroll', function () {
          clearTimeout(t);
          t = setTimeout(function () {
            var center = track.scrollLeft + track.clientWidth / 2;
            var best = alts[0], bd = Infinity;
            alts.forEach(function (a) {
              var c = a.offsetLeft + a.offsetWidth / 2;
              var d = Math.abs(c - center);
              if (d < bd) { bd = d; best = a; }
            });
            if (!best.classList.contains('is-selected')) select(best);
          }, 110);
        }, { passive: true });

        // Eenmalige swipe-hint
        if (!reduce && alts.length > 1 && 'IntersectionObserver' in window) {
          var hinted = false;
          var io = new IntersectionObserver(function (entries) {
            entries.forEach(function (en) {
              if (en.isIntersecting && !hinted) {
                hinted = true;
                setTimeout(function () {
                  track.scrollTo({ left: 46, behavior: 'smooth' });
                  setTimeout(function () { track.scrollTo({ left: 0, behavior: 'smooth' }); }, 460);
                }, 320);
                io.disconnect();
              }
            });
          }, { threshold: 0.4 });
          io.observe(group);
        }
      }
    });

    recomputeBundle();
  }

  function formatEuro(cents) {
    return '€' + (cents / 100).toFixed(2).replace('.', ',');
  }

  /* Leest alle showcases → updatet bundle-knop, closer-totaal en closer-items. */
  function recomputeBundle() {
    var showcases = Array.prototype.slice.call(document.querySelectorAll('[data-pl-arc-showcase]'));
    var ids = [];
    var total = 0;

    showcases.forEach(function (sc) {
      var vid = sc.getAttribute('data-selected-variant');
      if (vid) ids.push(vid);
      total += parseInt(sc.getAttribute('data-selected-price'), 10) || 0;

      // Closer-item met dezelfde fase bijwerken
      var phase = sc.getAttribute('data-phase');
      var li = document.querySelector('[data-pl-arc-closer][data-phase="' + phase + '"]');
      if (li) {
        var img = li.querySelector('[data-pl-arc-closer-img]');
        var titleEl = li.querySelector('[data-pl-arc-closer-title]');
        var priceEl = li.querySelector('[data-pl-arc-closer-price]');
        var thumb = sc.getAttribute('data-selected-thumb');
        var title = sc.getAttribute('data-selected-title');
        if (img && thumb) img.src = thumb;
        if (titleEl && title) titleEl.textContent = title.length > 32 ? title.slice(0, 31) + '…' : title;
        if (priceEl) priceEl.textContent = formatEuro(parseInt(sc.getAttribute('data-selected-price'), 10) || 0);
      }
    });

    var btn = document.querySelector('[data-pl-bundle-add]');
    if (btn && ids.length) btn.setAttribute('data-variant-ids', ids.join(','));

    var totalEl = document.querySelector('[data-pl-arc-total]');
    if (totalEl) totalEl.textContent = formatEuro(total);
  }

  function initBundleAdd() {
    var btn = document.querySelector('[data-pl-bundle-add]');
    if (!btn) return;

    btn.addEventListener('click', function () {
      var raw = btn.getAttribute('data-variant-ids') || '';
      var ids = raw.split(',').map(function (s) { return s.trim(); }).filter(Boolean);
      if (!ids.length) return;

      btn.setAttribute('data-state', 'loading');
      addSequentially(ids.slice(), [], []).then(function (result) {
        var added = result.added;
        var skipped = result.skipped;
        if (added.length === 0) {
          btn.removeAttribute('data-state');
          showNotice('Geen producten beschikbaar — probeer later opnieuw.');
          return;
        }
        btn.setAttribute('data-state', 'added');
        updateCartCount();
        if (skipped.length > 0) {
          showNotice(skipped.length === 1
            ? 'Eén product was uitverkocht en is overgeslagen — de rest zit in je winkelmand.'
            : skipped.length + ' producten waren uitverkocht en zijn overgeslagen — de rest zit in je winkelmand.');
        }
        setTimeout(function () {
          window.location.href = '/cart';
        }, skipped.length > 0 ? 2400 : 900);
      });
    });
  }

  /** Adds variants one-by-one so a single sold-out item doesn't fail the whole batch. */
  function addSequentially(remaining, added, skipped) {
    if (remaining.length === 0) {
      return Promise.resolve({ added: added, skipped: skipped });
    }
    var id = remaining.shift();
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: parseInt(id, 10), quantity: 1 })
    })
    .then(function (r) {
      if (r.ok) {
        added.push(id);
      } else {
        skipped.push(id);
      }
      return addSequentially(remaining, added, skipped);
    })
    .catch(function () {
      skipped.push(id);
      return addSequentially(remaining, added, skipped);
    });
  }

  function showNotice(msg) {
    var n = document.createElement('div');
    n.className = 'pl-arc__notice';
    n.textContent = msg;
    document.body.appendChild(n);
    requestAnimationFrame(function () { n.classList.add('is-visible'); });
    setTimeout(function () {
      n.classList.remove('is-visible');
      setTimeout(function () { n.remove(); }, 400);
    }, 3500);
  }

  function updateCartCount() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-pl-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
      })
      .catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
